interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  accentIcon?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  accentIcon = 'ri-emotion-happy-line',
}: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'text-center' : 'text-left'}>
      <div
        className={`inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-800 ${
          align === 'center' ? 'mx-auto' : ''
        }`}
      >
        <i className={`${accentIcon} text-sm`} />
        <span>{eyebrow}</span>
      </div>
      <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}